import EventReel from './EventReel';
import MembershipPanel from './MembershipPanel';
import SupportPanel from './SupportPanel';

function MembershipGateway() {
  return (
    <main className="gateway-shell">
      <div className="signal-grid" aria-hidden="true" />
      <div className="gateway-layout">
        <MembershipPanel />
        <EventReel />
      </div>
      <SupportPanel />
    </main>
  );
}

export default MembershipGateway;